import Builder from './builder';

class TagsBuilder extends Builder {
}

export default TagsBuilder;
